export const version = "random/5.0.6";
//# sourceMappingURL=_version.js.map